import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "DropdownLine.svg",
  "use": "DropdownLine.svg-usage",
  "viewBox": "0 0 9 11",
  "content": "<symbol viewBox=\"0 0 9 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"DropdownLine.svg\">\n<g clip-path=\"url(#DropdownLine.svg_clip0)\">\n<path d=\"M1.5 1.5L1.5 5.5C1.5 7.70914 3.29086 9.5 5.5 9.5L8 9.5\" stroke=\"#E8E8EB\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n<defs>\n<clipPath id=\"DropdownLine.svg_clip0\">\n<rect width=\"11\" height=\"9\" fill=\"white\" transform=\"matrix(4.37114e-08 -1 -1 -4.37114e-08 9 11)\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol